export function defaultTranslate (key: string, defaultValue: string = '') {
    return defaultValue || key
}
